<template>
    <div class="clear-cache">
      {{ msal.account?.username }}
        <div
            v-if="$checkRoles(['Administrator']) && this.selectedArena"
            :disabled="loading"
            class="clear-cache__btn"
            @click="clearCacheByArena"
        >
            <span v-if="!loading">Clear CDN cache on current arena</span>
            <Loader v-if="loading"></Loader>
        </div>
        <div
            v-if="
                $checkRoles(['Administrator']) &&
                !this.isPressing &&
                !this.selectedArena &&
                $isSpecialUser()
            "
            :disabled="loading"
            class="clear-cache__btn"
            @click="clearCache"
        >
            <span v-if="!loading">Arena 5.1 clear cache pipeline</span>
            <Loader v-if="loading"></Loader>
        </div>
        <div
            v-if="
                $checkRoles(['Administrator']) &&
                !this.isPressing &&
                !this.selectedArena &&
                $isSpecialUser()
            "
            :disabled="loading"
            class="clear-cache__btn"
            @click="clearAARPCache"
        >
            <span v-if="!loading">AARP clear cache pipeline</span>
            <Loader v-if="loading"></Loader>
        </div>
        <div
            v-if="
                $checkRoles(['Administrator']) &&
                !this.isPressing &&
                !this.selectedArena &&
                $isSpecialUser()
            "
            :disabled="loading"
            class="clear-cache__btn"
            @click="clearArkComCache"
        >
            <span v-if="!loading">Arkadium.com clear cache pipeline</span>
            <Loader v-if="loading"></Loader>
        </div>
    </div>
</template>

<script>
import config from '../../config';
import { ClearCacheService } from '../../services/ClearCacheService';

export default {
    name: 'ClearCacheBtn',
    components: {},
    props: ['selectedArena'],
    data() {
        return {
            pipelineStatus: '',
            isPressing: false,
            loading: false
        };
    },
    methods: {
        clearCacheByArena: function () {
            const clientDomain = this.selectedArena.domain.replace('www.', '');

            function clearByTag() {
                return ClearCacheService.clearCache('', [clientDomain], 'Tag', 'Delete')
                    .then((res) => {
                        this.$swal.fire({
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            icon: 'success',
                            title: `Cache cleared successfully by Tag: ${clientDomain}`,
                            text: 'You can find detailed logs in Network',
                        });
                    })
                    .catch((_) => {
                        this.$swal.fire({
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            icon: 'error',
                            title: `Clear cache error by Tag: ${clientDomain}`,
                            text: 'You can find detailed logs in Network',
                        });
                    });
            }

            function clearByFiles() {
                let containerName =
                    (process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live') ? 'arenaxstorage-blob' : 'arenaxstoragedev-blob';
                const indexUrl = containerName + '/arenax-index/' + clientDomain + '/index.html';
                const arenaDataUrl = containerName + '/arenax-index/' + clientDomain + '/assets/json/arena-data.json';
                const clientName = this.selectedArena.config.theme.client
                    ? this.selectedArena.config.theme.client
                    : 'default';
                const headerJs =
                    containerName + '/arenax-headers-prod/app/clients/' + clientName + '/' + clientName + '.js';
                const headerCss =
                    containerName + '/arenax-headers-prod/app/clients/' + clientName + '/' + clientName + '.css';
                const mobilePromoConfigPath =
                    containerName + '/arenax-index/_arena-shared-content_/ark-promo-apps/promo-apps-data.json';
                const flexibleGamesListPath =
                    containerName + '/arenax-index/_arena-shared-content_/ark-flexible-games/flexible-games-list.json';
                const files = [
                    indexUrl,
                    arenaDataUrl,
                    headerJs,
                    headerCss,
                    mobilePromoConfigPath,
                    flexibleGamesListPath,
                ];
                const langPrefix = ['de', 'en-au', 'en-nz', 'en-us', 'en', 'es', 'fr', 'it'];
                langPrefix.forEach(function (item, index) {
                    const arenaDataLanUrl =
                        containerName + '/arenax-index/' + clientDomain + '/assets/json/arena-data_' + item + '.json';
                    files.push(arenaDataLanUrl);
                });
                return ClearCacheService.clearCache('arenacloud.cdn.arkadiumhosted.com', files, 'Url', 'Delete')
                    .then((res) => {
                        this.$swal.fire({
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            icon: 'success',
                            title: `Cache by files was cleared successfully`,
                            text: 'You can find detailed logs in Network',
                        });
                    })
                    .catch((_) => {
                        this.$swal.fire({
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            icon: 'error',
                            title: `Clear cache error for ${JSON.stringify(files)}`,
                            text: 'You can find detailed logs in Network',
                        });
                    });
            }

            Promise.resolve()
                .then(() => {
                    this.loading = true;
                })
                .then(clearByTag.bind(this))
                .then(clearByFiles.bind(this))
                .then(() => {
                    this.loading = false;
                });
        },
        clearCache: function () {
            this.isPressing = true;
            new Promise((resolve) => {
                setTimeout(() => resolve('done'), 300e3);
            }).then(() => {
                this.isPressing = false;
            });

            this.loading = true;
            let cpCodes = ['150746', '894163', '148842', '143426']; // services and headers, arena SSR live/canary/dev
            ClearCacheService.clearCache('', cpCodes, 'CpCode', 'Delete')
                .then((res) => {
                    this.$swal.fire({
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1500,
                        icon: 'success',
                        title: `Cache cleared successfully by CpCodes`,
                        text: 'You can find detailed logs in Network',
                    });
                })
                .catch((_) => {
                    this.$swal.fire({
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1500,
                        icon: 'error',
                        title: `Clear cache error by CpCodes`,
                        text: 'You can find detailed logs in Network',
                    });
                })
                .then(() => {
                    // Trigger QA pipeline run (Swagger: qa-arena-monitor-cypress-run)
                    return this.$http.get(`${config.apiUrl}/runpipeline/qa-arena-monitor-cypress-run`).then(
                        () => {
                            this.$swal.fire({
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 2000,
                                icon: 'success',
                                title: 'QA pipeline started (Arena Monitor Cypress)',
                                text: '',
                            });
                        },
                        (error) => {
                            console.log(error);
                            this.$swal.fire({
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 2500,
                                icon: 'error',
                                title: 'Failed to start QA pipeline',
                                text: '',
                            });
                        }
                    );
                })
                .then(() => {
                    this.loading = false;
                });
        },
        clearAARPCache: function () {
            this.isPressing = true;
            new Promise((resolve) => {
                setTimeout(() => resolve('done'), 300e3);
            }).then(() => {
                this.isPressing = false;
            });

            this.loading = true;
            let cpCodes = ['150746', '148840', '1358556']; // services and headers, AARP SSR, AARP canary and dev
            ClearCacheService.clearCache('', cpCodes, 'CpCode', 'Delete')
                .then((res) => {
                    this.$swal.fire({
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1500,
                        icon: 'success',
                        title: `Cache cleared successfully by CpCodes`,
                        text: 'You can find detailed logs in Network',
                    });
                })
                .catch((_) => {
                    this.$swal.fire({
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1500,
                        icon: 'error',
                        title: `Clear cache error by CpCodes`,
                        text: 'You can find detailed logs in Network',
                    });
                })
                .then(() => {
                    this.loading = false;
                });
        },
        clearArkComCache: function () {
            this.isPressing = true;
            new Promise((resolve) => {
                setTimeout(() => resolve('done'), 300e3);
            }).then(() => {
                this.isPressing = false;
            });

            this.loading = true;
            ClearCacheService.clearCache('', ['shared-content-arkcom-game-arts'], 'Tag', 'Delete');
            let cpCodes = ['874370']; // ark.com
            ClearCacheService.clearCache('', cpCodes, 'CpCode', 'Delete')
                .then((res) => {
                    this.$swal.fire({
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1500,
                        icon: 'success',
                        title: `Cache cleared successfully by CpCodes`,
                        text: 'You can find detailed logs in Network',
                    });
                })
                .catch((_) => {
                    this.$swal.fire({
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1500,
                        icon: 'error',
                        title: `Clear cache error by CpCodes`,
                        text: 'You can find detailed logs in Network',
                    });
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style scoped src="./clearCache.scss" lang="scss"></style>
